import { render, staticRenderFns } from "./page-res.vue?vue&type=template&id=1d00f1d8&scoped=true&"
import script from "./page-res.vue?vue&type=script&lang=js&"
export * from "./page-res.vue?vue&type=script&lang=js&"
import style0 from "./page-res.vue?vue&type=style&index=0&id=1d00f1d8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d00f1d8",
  null
  
)

export default component.exports